module.exports = __webpack_public_path__ + "static/img/Logo_Agora.89a0d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_Agora.png
// module id = 454n
// module chunks = 2